import { render, staticRenderFns } from "./AdminUserForm.vue?vue&type=template&id=ea23cffe&"
import script from "./AdminUserForm.vue?vue&type=script&lang=js&"
export * from "./AdminUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports